import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "图层_1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-504"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.232 5.448a.5.5 0 0 0-.93-.368c-.082.205-2.128 5.042-10.69 5.233a.5.5 0 0 0 .011 1h.01c9.266-.207 11.509-5.634 11.6-5.865zM4.998 7.686a.988.988 0 1 0-.988-.988.988.988 0 0 0 .988.988zM8.854 6.23a.988.988 0 1 0-.988-.987.988.988 0 0 0 .988.988zm2.321 3.933a.988.988 0 1 0 .988.988.987.987 0 0 0-.988-.988zm-2.541 1.241a.597.597 0 1 0 .597.597.597.597 0 0 0-.597-.597zm4.349-2.994a.597.597 0 1 0 .597.597.597.597 0 0 0-.597-.597zm-9.737.373a.637.637 0 1 0-.636-.637.637.637 0 0 0 .636.637zm3.791-4.528a.541.541 0 1 0-.54-.542.541.541 0 0 0 .54.542z",
  class: "cls-1"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.998 7.328a.637.637 0 1 0 .636-.637.636.636 0 0 0-.636.637z",
  class: "cls-1"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
export default { render: render }